import React, { MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";
import classnames from "classnames";

export default function EventContentTab(props: {
	textContent: string;
	isActive: boolean;
	onClick: MouseEventHandler<HTMLButtonElement>;
	disabled?: boolean;
	hasBBIcon?: boolean;
	hasBTIcon?: boolean;
	hasNewTag?: boolean;
}) {
	const { t } = useTranslation();

	return (
		<button
			type="button"
			className={classnames(
				"tabs__item tabs--boxed__item tabs--scroll__item",
				{
					"is-active": props.isActive,
					"is-disabled": props.disabled,
				}
			)}
			onClick={(e) => {
				props.onClick(e);
			}}
			disabled={props.disabled}
		>
			{props.hasBBIcon && (
				<i
					className={classnames(
						"tabs__frame tabs--boxed__frame u-icon u-icon--sml u-icon--bb--active",
						{
							// "u-color--core--snow": props.isActive,
						}
					)}
				/>
			)}
			{props.hasBTIcon && (
				<i
					className={
						"tabs__frame tabs--boxed__frame u-icon u-icon--sml" +
						(props.isActive
							? " u-icon--betting-tip--str u-color--bet--returned"
							: " u-icon--betting-tip--alt")
					}
				/>
			)}
			<div className="tabs__title tabs--boxed__title">
				{props.textContent}
			</div>

			{(props.hasBTIcon || props.hasNewTag) && (
				<span className="tabs__tag tag tag--tny tag--bolder">
					{t<string>("CASINO.NEW_GAME_LABEL")}
				</span>
			)}
		</button>
	);
}
